/* eslint-disable prettier/prettier */
// src/modules/owner/pages/actions/linkPagamento/main.jsx

import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Fab, Button } from '@mui/material';
import { Add, BarChart, Delete, Edit, Stop, Share, FileCopy } from '@mui/icons-material';
import MaterialGrid from '@material-ui/core/Grid';
import { isMobile } from 'react-device-detect';
import GeneralGrid from 'common/components/layout/grid/GeneralGrid';
import Table from 'common/components/table/table-material';
import { ActionNameElement, ColumnsBelowSearch } from 'common/components/table/tableComponents';
import { appColors } from 'styles/colors';
import LinkPagamentoModal from './components/LinkPagamentoModal';
import PrimaryButton from 'common/components/buttons/primaryButton';
import axios from 'axios';
import { BASE_API, USER_TOKEN } from 'config/consts';
import { getList as getLottiesList } from '../../lotties/lottiesActions';
import { getFormValues, reduxForm, initialize } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ShareModal from '../tanqueCheio/components/ShareModal';
import ResultsModal from '../vendasOnlineParceiro/components/ResultsModal';
import { LINK_PAGAMENTO_TYPE_ID } from './types';
import {
  CHILD_ACTION_EDIT_BLOCKED_MESSAGE,
  getDefaultStationId,
  getUserStations,
  isMultiStationChildAction,
} from '../helpers/clubsMultiStation';

function Main(props) {
  const [open, setOpen] = useState(false);
  const [tablePage, setTablePage] = useState(1);
  const [shownPerPage, setShownPerPage] = useState(5);
  const [nameSearched, setNameSearched] = useState('');
  const [value, setValue] = useState(0);
  const [form, setForm] = useState(props.formValues || {});
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [resultsModalOpen, setResultsModalOpen] = useState(false);
  const stationId = getDefaultStationId(props.auth);

  const handleOpen = useCallback(() => {
    const userStations = getUserStations(props.auth);
    const currentStation =
      userStations.find((station) => station.id === stationId) || userStations[0];
    const initialValues = currentStation
      ? { stations_field: [{ id: currentStation.id, title: currentStation.name || currentStation.title }] }
      : {};
    if (props.initializeForm) {
      props.initializeForm(initialValues);
    }
    setSelectedActivity(null);
    setForm(initialValues);
    setOpen(true);
  }, [props, stationId]);
  const handleClose = useCallback(() => setOpen(false), []);

  const handleEditActivity = useCallback(async (activity) => {
    if (isMultiStationChildAction(activity) || isMultiStationChildAction(activity?.rawData)) {
      alert(CHILD_ACTION_EDIT_BLOCKED_MESSAGE);
      return;
    }
    console.log('Editando atividade:', activity.id);
    
    try {
      const token = JSON.parse(localStorage.getItem(USER_TOKEN));
      const response = await axios.get(`${BASE_API}/actions/${activity.id}`, {
        headers: {
          Authorization: `${token}`,
        },
      });
      
      const activityData = response.data;
      if (isMultiStationChildAction(activityData)) {
        alert(CHILD_ACTION_EDIT_BLOCKED_MESSAGE);
        return;
      }
      
      let parsedBody = {};
      const rawConfig = activityData.station_specific_data || activityData.body;
      if (rawConfig) {
        try {
          parsedBody = typeof rawConfig === 'string' ? JSON.parse(rawConfig) : rawConfig;
        } catch (e) {
          console.warn('Erro ao fazer parse do body:', e);
        }
      }

      let rawCategories = [];
      if (Array.isArray(activityData.category_actions) && activityData.category_actions.length > 0) {
        rawCategories = activityData.category_actions.map((item) => item.category || item);
      } else if (Array.isArray(activityData.categories) && activityData.categories.length > 0) {
        rawCategories = activityData.categories;
      } else if (Array.isArray(parsedBody.categories_field) && parsedBody.categories_field.length > 0) {
        rawCategories = parsedBody.categories_field;
      }
      const categoriesField = rawCategories.map((cat) => {
        if (typeof cat === 'object' && cat !== null) {
          return { id: cat.id, title: cat.title || cat.name || '' };
        }
        return { id: cat, title: '' };
      });

      const userStations = getUserStations(props.auth);
      let rawStations = parsedBody.stations_field || [];
      if (rawStations.length === 0 && activityData.station_id) {
        const activityStation = userStations.find((s) => s.id === activityData.station_id);
        if (activityStation) {
          rawStations = [{ id: activityStation.id, title: activityStation.name }];
        }
      }
      const stationsField = Array.isArray(rawStations)
        ? rawStations.map((station) => {
            const id = typeof station === 'object' ? station.id : station;
            const userStation = userStations.find((s) => s.id === id);
            return {
              id,
              title: userStation?.name || userStation?.title || station?.title || station?.name || '',
            };
          })
        : [];
      const { stations_field: _stationsField, categories_field: _categoriesField, ...restParsedBody } = parsedBody;

      const formData = {
        id: activityData.id,
        ...restParsedBody,
        ...activityData,
        name: activityData.name || parsedBody.name,
        body_name: activityData.name,
        body_description: activityData.description || parsedBody.description,
        body_summary: activityData.summary || parsedBody.summary,
        categories_field: categoriesField,
        groupings_field: activityData.groupings || parsedBody.groupings,
        stations_field: stationsField,
        station_id: parsedBody.station_id || activityData.station_id,
        image: activityData.image || parsedBody.image,
        start: activityData.start,
        end: activityData.end,
        participationStart: activityData.participationStart,
        participationEnd: activityData.participationEnd,
      };

      if (props.initializeForm) {
        props.initializeForm(formData);
      }
      
      setSelectedActivity(activity);
      setForm(formData);
      setValue(0);
      setOpen(true);
    } catch (error) {
      console.error('Erro ao carregar dados da atividade:', error);
      const fallbackData = {
        ...activity.rawData,
        name: activity.name,
        id: activity.id
      };
      
      if (props.initializeForm) {
        props.initializeForm(fallbackData);
      }
      
      setSelectedActivity(activity);
      setForm(fallbackData);
      setValue(0);
      setOpen(true);
    }
  }, [props]);

  const handleViewResults = useCallback((activity) => {
    setSelectedActivity(activity);
    setResultsModalOpen(true);
  }, []);

  const handleShareActivity = useCallback((activity) => {
    setSelectedActivity(activity);
    setShareModalOpen(true);
  }, []);

  const fetchLinkPagamentoActivities = useCallback(async () => {
    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem(USER_TOKEN));
      const offset = (tablePage - 1) * shownPerPage;
      
      const [dataResponse, totalResponse] = await Promise.all([
        axios.get(
          `${BASE_API}/actions-list-table/?where[station_id]=${stationId}&where[type_id]=${LINK_PAGAMENTO_TYPE_ID}&where[active]=1&where[is_draft]=0&where[limit]=${shownPerPage}&where[offset]=${offset}`,
          {
            headers: {
              Authorization: `${token}`,
            },
          }
        ),
        axios.get(
          `${BASE_API}/actions/total/?where[station_id]=${stationId}&where[type_id]=${LINK_PAGAMENTO_TYPE_ID}&where[active]=1&where[is_draft]=0`,
          {
            headers: {
              Authorization: `${token}`,
            },
          }
        )
      ]);

      const activities = dataResponse.data || [];
      setTotalRecords(totalResponse.data.total || 0);

      const formattedData = activities.map(activity => {
        let imageUrl = null;
        
        if (activity.image && activity.image.trim() !== '') {
          if (typeof activity.image === 'string') {
            if (activity.image.includes('http')) {
              imageUrl = activity.image;
            } else if (activity.image.startsWith('https://s3.amazonaws.com/rilato.app.files/')) {
              imageUrl = activity.image;
            } else {
              imageUrl = `https://s3.amazonaws.com/rilato.app.files/${activity.image}`;
            }
          }
        } else {
          imageUrl = null;
        }

        return {
          id: activity.id,
          name: activity.name || 'Nome não disponível',
          type: 'Link de Pagamento',
          entity: activity.station?.name || 'N/A',
          startDate: activity.start ? new Date(activity.start).toLocaleDateString('pt-BR') : new Date(activity.createdAt).toLocaleDateString('pt-BR'),
          endDate: activity.end ? new Date(activity.end).toLocaleDateString('pt-BR') : 'Não definido',
          image: imageUrl,
          parent_action_id: activity.parent_action_id || null,
          rawData: activity
        };
      });

      // Aplicar filtro de busca por nome
      const filteredData = nameSearched
        ? formattedData.filter(item =>
            typeof item.name === 'string' &&
            item.name.toLowerCase().includes(nameSearched.toLowerCase())
          )
        : formattedData;

      setData(filteredData);
    } catch (error) {
      console.error('Erro ao buscar atividades:', error);
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [nameSearched, tablePage, shownPerPage, stationId]);

  const handleEndActivity = useCallback(async (activity) => {
    const activityId = activity?.id || activity;
    if (isMultiStationChildAction(activity) || isMultiStationChildAction(activity?.rawData)) {
      alert('Esta atividade foi publicada pela entidade pai e só pode ser encerrada lá.');
      return;
    }
    if (!window.confirm('Tem certeza que deseja encerrar esta atividade?')) {
      return;
    }
    try {
      const token = JSON.parse(localStorage.getItem(USER_TOKEN));
      await axios.put(
        `${BASE_API}/archive-action/${activityId}`,
        {},
        { headers: { Authorization: `${token}` } }
      );
      alert('Atividade encerrada com sucesso!');
      fetchLinkPagamentoActivities();
    } catch (error) {
      console.error('Erro ao encerrar atividade:', error);
      alert(error.response?.data?.messages?.[0] || 'Erro ao encerrar atividade. Tente novamente.');
    }
  }, [fetchLinkPagamentoActivities]);

  useEffect(() => {
    props.getLottiesList();
    fetchLinkPagamentoActivities();
  }, [props, fetchLinkPagamentoActivities]);

  useEffect(() => {
    if (props.location && props.location.query && props.location.query.openModal === '1') {
      setOpen(true);
    }
  }, [props.location]);

  useEffect(() => {
    setForm(props.formValues || {});
  }, [props.formValues]);

  function goBack() {
    setValue(value - 1);
  }

  function handleOpenConfirmation() {
    setOpenConfirmation(true);
  }

  function handleCancelClose() {
    setOpenConfirmation(false);
  }

  function handleNativeChange(_e, newValue) {
    setValue(newValue);
  }

  const handlePageChange = useCallback((newPage) => {
    setTablePage(newPage + 1);
  }, []);

  const handleRowsPerPageChange = useCallback((newRowsPerPage) => {
    setShownPerPage(newRowsPerPage);
    setTablePage(1);
  }, []);

  async function handleChange() {
    fetchLinkPagamentoActivities();
  }

  function onDialogClose() {
    setOpenConfirmation(false);
    setOpen(false);
    setSelectedActivity(null);
    setForm(props.formValues || {});
    setTimeout(() => {
      props.router.push('/owner/link-pagamento');
    }, 100);
  }

  const columns = isMobile
    ? [
        {
          field: 'name',
          title: 'Nome',
          render: rowData => (
            <ActionNameElement
              actionName={rowData.name}
              image={rowData.image}
            />
          ),
        },
        {
          field: 'type',
          title: 'Tipo',
          render: rowData => <ActionNameElement actionName={rowData.type} />,
        },
        {
          field: 'actions',
          title: 'Ações',
          headerCenter: true,
          hasOnClick: true,
          render: () => (
            <ColumnsBelowSearch
              buttons={{
                namedButtons: [],
                iconButtons: [{
                  name: 'edit',
                  onClick: () => {},
                  color: appColors.primary
                }],
              }}
            />
          ),
        },
      ]
    : [
        {
          field: 'name',
          title: 'Nome',
          render: rowData => (
            <ActionNameElement
              actionName={rowData.name}
              image={rowData.image}
            />
          ),
        },
        {
          field: 'type',
          title: 'Tipo',
          render: rowData => <ActionNameElement actionName={rowData.type} />,
        },
        {
          field: 'entity',
          title: 'Entidade',
          render: rowData => <ActionNameElement actionName={rowData.entity} />,
        },
        {
          field: 'startDate',
          title: 'Início da Publicação',
          render: rowData => <ActionNameElement actionName={rowData.startDate} />,
        },
        {
          field: 'endDate',
          title: 'Fim da Publicação',
          render: rowData => <ActionNameElement actionName={rowData.endDate} />,
        },
        {
          field: 'actions',
          title: 'Ações',
          headerCenter: true,
          hasOnClick: true,
          render: rowData => {
            const isChild = isMultiStationChildAction(rowData);
            return (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, maxWidth: 200 }}>
              <Box sx={{ display: 'flex', gap: 0.5 }}>
                {!isChild && (
                <Button
                  size="small"
                  onClick={() => handleEditActivity(rowData)}
                  sx={{ p: 1, minWidth: 'auto' }}
                  title="Editar"
                >
                  <Edit sx={{ fontSize: 18, color: '#666' }} />
                </Button>
                )}
                <Button
                  size="small"
                  onClick={() => handleViewResults(rowData)}
                  sx={{ p: 1, minWidth: 'auto' }}
                  title="Ver Resultados"
                >
                  <BarChart sx={{ fontSize: 18, color: '#666' }} />
                </Button>
                {!isChild && (
                <Button
                  size="small"
                  onClick={() => handleEndActivity(rowData)}
                  sx={{ p: 1, minWidth: 'auto' }}
                  title="Encerrar"
                >
                  <Stop sx={{ fontSize: 18, color: '#666' }} />
                </Button>
                )}
                <Button
                  size="small"
                  onClick={() => handleShareActivity(rowData)}
                  sx={{ p: 1, minWidth: 'auto' }}
                  title="Divulgar"
                >
                  <Share sx={{ fontSize: 18, color: '#666' }} />
                </Button>
              </Box>
            </Box>
            );
          },
        },
      ];

  if (!props.auth.user.establishments[0].digital_account) {
    return (
      <section style={{ height: '100vh' }}>
        <MaterialGrid container spacing={3} alignItems="center">
          <MaterialGrid item xs={12} md={6}>
            <Typography variant="h5" gutterBottom>
              Você ainda não possui uma conta bancária cadastrada para poder gerar links de pagamento
            </Typography>
            <PrimaryButton onClick={() => props.router.push('/owner/profile')}>
              Cadastre agora
            </PrimaryButton>
          </MaterialGrid>
        </MaterialGrid>
      </section>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', p: 2 }}>
      <GeneralGrid container spacing={3}>
        <GeneralGrid item container xs={12} justifyContent="center">
          <GeneralGrid item xs={12} style={{ width: isMobile ? '85vw' : undefined }}>
            <Table
              toolbarSearch
              disableSearchIconClick
              searchBarOnChange={setNameSearched}
              searchPlaceholder="Pesquisar atividade"
              title="Gerenciador Link de Pagamento"
              columns={columns}
              rows={data}
              dataType="linkPagamento"
              setAPIPage={handlePageChange}
              setAPILimit={handleRowsPerPageChange}
              countFromAPI={totalRecords}
              loading={loading}
              mobileTable={isMobile}
              hasBorder={!isMobile}
              currentPage={tablePage - 1}
              rowsPerPage={shownPerPage}
              rowsPerPageOptions={[5, 10, 25]}
              defaultRowsPerPage={5}
            />
          </GeneralGrid>
        </GeneralGrid>
      </GeneralGrid>

      <Fab
        color="primary"
        sx={{ position: 'fixed', bottom: 100, right: 64 }}
        onClick={handleOpen}
      >
        <Add />
      </Fab>

      <LinkPagamentoModal
        visible={open}
        onClose={handleClose}
        onClickProgress={handleChange}
        editMode={!!selectedActivity}
        activityId={selectedActivity?.id}
      />
      <ResultsModal
        open={resultsModalOpen}
        onClose={() => setResultsModalOpen(false)}
        activity={selectedActivity}
      />
      <ShareModal
        open={shareModalOpen}
        onClose={() => {
          setShareModalOpen(false);
          setSelectedActivity(null);
        }}
        activity={selectedActivity}
      />
    </Box>
  );
}

Main.propTypes = {
  auth: PropTypes.object.isRequired,
  formValues: PropTypes.any,
  getLottiesList: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  auth: state.auth,
  formValues: getFormValues('linkPagamentoForm')(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ 
    getLottiesList,
    initializeForm: (data) => initialize('linkPagamentoForm', data)
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Main);
